import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { ArrowRight, Lock } from 'lucide-react';

import { MeshBackground } from '../../sub/mcsa/MeshBackground';
import { CyberCharacter } from '../../sub/mcsa/CyberCharacter';

const JOURNEY_STEPS = [
    { number: 1, title: 'Goals', description: 'Set your focus' },
    { number: 2, title: 'Baseline', description: 'Map your reflexes' },
    { number: 3, title: 'Shield Plan', description: 'See what to strengthen' },
];

export const MCSAWelcome = () => {
    return (
        <section className='mcsa_welcome__page'>
            <MeshBackground />

            <div className='mcsa_welcome__content'>
                <div className='mcsa_welcome__visual'>
                    <CyberCharacter variant='welcome' />
                </div>

                <p className='text-sm text-semibold text-uppercase color--primary mcsa_welcome__eyebrow'>
                    MindShield Atlas
                </p>
                <h1 className='text-light color--primary mcsa_welcome__headline'>
                    Your journey through the <span className='mcsa_welcome__headline__gradient'>mind</span>
                </h1>
                <p className='text-lg color--txt-tertiary mcsa_welcome__body'>
                    Clicks, scrolls, and pauses can reveal how you react under pressure. MindShield Atlas turns that signal into a private resilience map.
                </p>

                <div className='mcsa_welcome__journey' aria-label='Assessment journey'>
                    {JOURNEY_STEPS.map((step, index) => (
                        <Fragment key={step.number}>
                            {index > 0 && <span className='mcsa_welcome__journey__line' aria-hidden='true' />}
                            <div className='mcsa_welcome__journey__step'>
                                <span className='mcsa_welcome__journey__number'>{step.number}</span>
                                <span className='mcsa_welcome__journey__copy'>
                                    <span className='mcsa_welcome__journey__title'>{step.title}</span>
                                    <span className='mcsa_welcome__journey__description'>{step.description}</span>
                                </span>
                            </div>
                        </Fragment>
                    ))}
                </div>

                <Link
                    className='btn btn--lg btn--radius-full btn--primary mcsa_welcome__start_btn'
                    to='/mcsa/journey'
                >
                    <span>Start</span>
                    <ArrowRight />
                </Link>

                <p className='text-sm color--txt-tertiary mcsa_welcome__privacy'>
                    <Lock />
                    10 minutes · Private by design
                </p>
            </div>
        </section>
    );
};
